module.exports = __webpack_public_path__ + "img/DB4-1920_05.4e3f5fd7.jpg";